module.exports = __webpack_public_path__ + "media/images/arrows/bullet-orange-b92e2b6b404d89132eab2456a9acedda.svg";